import isBefore from '../node_modules/date-fns/esm/isBefore/index.js';
import parseDate from './parse-date.js';

/**
 * @func isBefore
 * @param {date} firstDate - first date to be compared (accepts date string, ISO string, or date object)
 * @param {date} secondDate - second date to be compared (accepts date string, ISO string, or date object)
 * @return {boolean}
 * @desc Returns true if the first date is earlier than the second
 * ```js
 * isBefore('1/1/2020', '1/2/2020');
 * // returns true
 * ```
 * @memberof module:Date
 * @instance
 */
function before(firstDate, secondDate) {
    const parsedFirstDate = parseDate(firstDate);
    const parsedSecondDate = parseDate(secondDate);
    if (!parsedFirstDate || !parsedSecondDate)
        return false;
    return isBefore(parsedFirstDate, parsedSecondDate);
}

export { before as default };
